<template>
    <v-container fluid class="myt-conformation">
        <v-row v-if="data && data.stepOneData && data.stepOneData.testName">
            <v-col cols="12" sm="12">
                <div class="custom-question-msg" >
                        <div class="subject-name">
                        <span class="Syllabus-title">Syllabus For Test:</span><span> {{ data.stepOneData.testName }}</span>
                        </div>
                    <div
                        class="sidebar-block"
                        v-if="
                            data && data.tabsList.length
                        "
                    >
                        <div class="subject-chapter-name-block">
                            <div class="data-tabsList"
                                v-for="item in data.tabsList"
                                :key="item.id"
                            >
                                <div class="tabsList">
                                    <div
                                        class="sidechaptertopiclistpanel-name"
                                        v-if="
                                            item.checked &&
                                                !item.showIndexTopics
                                        "
                                    >
                                        {{ item.title }}
                                    </div>
                                    <div
                                        class="chapter-name"
                                        v-if="
                                            !item.checked &&
                                                item.showIndexTopics
                                        "
                                    >
                                        {{ item.title }}
                                    </div>
                                </div>
                                <div
                                    v-if="item.showIndexTopics"
                                    class="topics-name"
                                >
                                    <div
                                        v-for="child in item.chapters"
                                        :key="child.id"
                                    >
                                        <div
                                            v-if="child.checked"
                                            class="topics-title"
                                        >
                                            {{ child.title }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </v-col>
			<div class="selectedSubject-col">
                <div class="create-test-selectedSubject ">
                    <v-btn
                        class="left-btn cust-btn create-tst-btn"
                        width="25%"
                        color="primary"
                        @click="onClose({status:false,confirm:false})"
                        >Change Syllabus</v-btn
                    >
                </div> 
                <div class="create-test-selectedSubject ">
                    <v-btn
                        class="left-btn cust-btn create-tst-btn"
                        width="25%"
                        color="primary"
                        @click="onClose({status:false,confirm:true})"
                        >Create Test</v-btn
                    >
                </div>
			</div>
        </v-row>
    </v-container>
</template>
<script>
import { mapActions, mapState } from "vuex";

export default {
    name: "customizedTestsSubPopup",
    props: ["onClose", "status", "data", "onCustomizeClick"],
    data() {
        return {
            dummyOptions: [],
            dummyOptionsABC: [],
            dummyOptionsPQR: [],
            subQuestionLength: 0,
            disableCreateTest: false,
            showCustomizeSyllabus: false,
        };
    },
};
</script>
